<template>
    <div class="material-vue">

    </div>
</template>
  
<script>
import CommonForm from '@/components/CommonForm'
export default {
    data () {
        return {
            form: {},
            searchItems: [
                {
                    type: "select",
                    value: "feedbackType",
                    label: "反馈类型",
                    options: FEEDBACK_TYPE,
                },
                {
                    type: "select",
                    value: "feedbackStatus",
                    label: "反馈状态",
                    options: FEEDBACK_STATUS,
                },
                {
                    type: "input",
                    value: "userId",
                    label: "用户id",
                },
                {
                    type: "input",
                    value: "taskId",
                    label: "任务id",
                },
            ],
        }
    },
    components: {
        CommonForm
    },
    methods: {
    },
    mounted () {
        this.getList()
    }

}
</script>
  
<style lang="scss" scoped>
.user-list {
    width: 100%;
    height: 100%;

    &-title {
        min-height: 50px;
        max-height: 100px;
        background: #fff;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    /deep/ .el-table__row {
        .handle {
            .update {
                margin: 0 20px;
            }

            .el-switch,
            .update,
            .el-icon-delete {
                cursor: pointer;
            }
        }
    }

    /deep/ .pagination {
        width: 100%;
        background: #fff;
        position: absolute;
        right: 0;
        bottom: -25px;
    }
}
</style>